export default "__VITE_ASSET__DnV7HDbX__"